/**
 * List Schema of OcorrenciaTrackingResponsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {OcorrenciaTrackingResponsavel} from '@/model/resource/OcorrenciaTrackingResponsavel'

/* TODO: review generated schema */
export class ListOcorrenciaTrackingResponsavelSchema extends Schema {
  readonly name = 'ListOcorrenciaTrackingResponsavel'

  readonly fieldSet: FieldSet<OcorrenciaTrackingResponsavel> = {
    idOcorrenciaTrackingResponsavelPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    idResponsavelFk: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        class: 'w-32',
        content: Helper.cnpj(schema.model.responsavel?.cnpj),
      },
    }),
    razaoSocial: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.razaoSocial || '',
      },
    }),
    idOcorrenciaExterna: (): FieldComponent => ({
      is: Component.Render,
    }),
    descricao: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
